import classNames from 'classnames';
import styles from './ServiceNavigation.module.scss';
import { Link, Icon } from 'ui/components';
import IconChevronRight from 'ui/icons/icon-global-chevron-right.svg';
import { useEffect, useState } from 'react';

export interface ServiceNavigationProps {
	className?: string;
	serviceNav?: Umbraco.Link;
	style?: 'primary';
	serviceNavigationItems?: Models.ServiceNavigation;
}

export const ServiceNavigation: React.FC<ServiceNavigationProps> = ({ serviceNavigationItems }) => {
	return (
		<ul className={styles.ServiceNavigation__list}>
			{serviceNavigationItems &&
				serviceNavigationItems?.serviceNav?.map((navItem, index) => (
					<li key={index} className={classNames(styles.ServiceNavigation__item)}>
						<Link
							className={classNames(styles.ServiceNavigation__link)}
							title={navItem?.content?.properties?.link?.name}
							url={navItem?.content?.properties?.link?.url}
						>
							<span className={styles.ServiceNavigation__text}>{navItem?.content?.properties?.link?.name}</span>
							<Icon className={styles.ServiceNavigation__icon}>
								<IconChevronRight />
							</Icon>
						</Link>
					</li>
				))}
		</ul>
	);
};
